import React from 'react'
import { useTranslation } from "react-i18next";

const ViewTextGeneric = ({ values, field, moduleText, occupation = 6, css_class = '' }) => {
    const { t } = useTranslation();

    const hasInformation = values[field] ? true : false;

    const ViewTextGenericRender = () => {
        if(!hasInformation){
            return null;
        }

        return (
            <div className={`col-md-${occupation} ${css_class} viewContentGroup`}>
                <div>
                    <div htmlFor={field} className="tit-view-view tit-content-view-view">
                        {t(`${moduleText}.synthetic.${field}`)}
                    </div>
                    <div
                        className="txt-view viewContentTxt"
                        name={field}
                        id={field}
                    >{values[field] || ""}</div>
                </div>
            </div>
        );
    }

    return (
        <ViewTextGenericRender />
    )
}

export default ViewTextGeneric;
